export const fileDownload = (response) => {
  const contentType = response.headers["content-type"];
  const previewUrl = URL.createObjectURL(
    new Blob([response.data], { type: contentType })
  );
  window.open(previewUrl, "_blank");
};
